import { render } from "./IconPlayCircleFilled.vue?vue&type=template&id=97dfd83a"
import script from "./IconPlayCircleFilled.vue?vue&type=script&lang=js"
export * from "./IconPlayCircleFilled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__